import { CardPageMenuData, FullscreenImage } from "pages/Companies/CardPage";
import {
  Children,
  ReactNode,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from "react";
import menuIcon from "assets/Icon_Btn_03.png";
import { clearRolesFormsDetailsData } from "reducers/roles";
import {
  CrudItems,
  CrudOptions,
  Menu,
  applyMaybeBoolean,
  applyMaybeString,
  useMenuState,
} from "components/Category/CrudMenu";
import { TableInfo } from "api";
import React from "react";
import { RightPanel } from "components/rightPanel/RightPanel";
import { RightMenuItems } from "components/rightMenu/RightMenu";
import { NestedListItemActionTypes } from "components/Category/Category";
import { customUseOnClickOutside } from "components/helpers/CustomFieldRenderers/SearchListFieldRenderer/SearchListRenderer";

const TEST_IMAGE =
  "https://uatblobstorage2019.blob.core.windows.net/principle-principle-secure/documents/a8531547-5e3e-4b08-807f-ac2dea4d4c49/Test PNG File.PNG?skoid=ddd10f8b-9fbb-4029-85b7-5f3733cc8b38&sktid=d8b5de79-0700-4432-82ba-47f28b5f3cdd&skt=2024-05-13T08%3A18%3A15Z&ske=2024-05-13T09%3A33%3A15Z&sks=b&skv=2021-12-02&sv=2021-12-02&st=2024-05-13T08%3A18%3A16Z&se=2024-05-13T09%3A33%3A16Z&sr=b&sp=r&sig=U2nvlZAMWsesrMxLjxBPsiDgIjfqKCZlTiLjlX2W8e8%3D";

const TEST_IMAGE_2 =
  "https://uatblobstorage2019.blob.core.windows.net/principle-principle-secure/documents/2c571a8b-c303-4ddc-ad03-55c35e8ae659/Test profile picture.PNG?skoid=ddd10f8b-9fbb-4029-85b7-5f3733cc8b38&sktid=d8b5de79-0700-4432-82ba-47f28b5f3cdd&skt=2024-05-13T09%3A10%3A11Z&ske=2024-05-13T10%3A25%3A11Z&sks=b&skv=2021-12-02&sv=2021-12-02&st=2024-05-13T09%3A10%3A11Z&se=2024-05-13T10%3A25%3A11Z&sr=b&sp=r&sig=YatsyZ%2B0VJZcktiQQzCfVYcMassk1fzIg5or8Z15Nf8%3D";

type Props = {
  title: string;
  image?: string;

  data: any;
  dataId: any;

  customContent?: ReactNode;

  customIcon?: ReactNode;
  classname?: string;
  type?: string | null;
  type2?: string | null;
  projectID?: boolean;
  clientID?: boolean;
  maxTitleLength?: number;
  centerCardPageTitle?: boolean;
  crudItems: any;
  permissions: any;
  disableMenuItemData: any;
  rolePermissions?: any;
  oppositePermissions?: any;
  idColumn: string;
  table: TableInfo;
  footerActionType: Partial<NestedListItemActionTypes>;
  LargeRightPanel?: boolean | ((action?: string | null) => boolean);
  hideIcon?: boolean;
  combineTitleAndType?: boolean;
  hideMenuOptions?: boolean;
  imageCardColumn?: string;
  index: number;
  fullscreenImage: FullscreenImage | null;
  setFullscreenImage: React.Dispatch<SetStateAction<FullscreenImage | null>>;
  overrideFooterButtonText?: string;
};

export type CardViewTitleTooltipProps = {
  title: string | null;
};
export const CardViewTitleTooltip: React.FC<CardViewTitleTooltipProps> = ({
  title,
}) => {
  return (
    <div className="CardViewTooltip">
      <div className="Text">{`${title ?? ""}`}</div>

      <div className="Arrow"></div>
    </div>
  );
};

export const handleTitleOnMouseOver = (
  longTitle: boolean,
  setShowTooltip: React.Dispatch<SetStateAction<boolean>>
) => {
  if (longTitle) {
    setShowTooltip(true);
  }
};

export const handleTitleOnMouseLeave = (
  longTitle: boolean,
  setShowTooltip: React.Dispatch<SetStateAction<boolean>>
) => {
  if (longTitle) {
    setShowTooltip(false);
  }
};

const MAX_TITLE_LENGTH = 30;

export const CardPrototype = ({
  data,
  title,
  image,
  dataId,
  //children,
  customContent,
  classname,
  type,
  type2,
  projectID,
  clientID,
  maxTitleLength,
  centerCardPageTitle,
  crudItems,
  permissions,
  disableMenuItemData,
  rolePermissions,
  oppositePermissions,
  idColumn,
  table,
  footerActionType,
  LargeRightPanel,
  hideIcon,
  customIcon,
  combineTitleAndType,
  hideMenuOptions,
  imageCardColumn,
  index,
  fullscreenImage,
  setFullscreenImage,
  overrideFooterButtonText,
}: Props) => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [longTitle, setlongTitle] = useState<boolean>(false);
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const [imagePath, setImagePath] = useState<string | null>(null);

  const [menu, menuActions] = useMenuState({
    menuItems: crudItems,
    selectedData: [data],
    permissions,
    table: table as TableInfo,
    idColumn,
    disableMenuItemData,
    rolePermissions,
    oppositePermissions,
  });
  const items = menu.menuItems.menuItems;

  const footerAction = useMemo(
    () => items.find((item: any) => item.permissionKey === footerActionType),
    [footerActionType, items]
  );

  useEffect(() => {
    if (
      maxTitleLength &&
      title &&
      typeof title === "string" &&
      title.trim().length >= maxTitleLength - 3 // -3 for ellipsis
    ) {
      setlongTitle(true);
    } else {
      setlongTitle(false);
    }
  }, [title]);

  const bind = customUseOnClickOutside(() => {
    setMenuOpen(false);
  }, true);

  const iconText = title ? title.charAt(0) : "-";

  useEffect(() => {
    if (imageCardColumn && data && data.hasOwnProperty(imageCardColumn)) {
      const tempImagePath = data[imageCardColumn];

      if (typeof tempImagePath === "string") {
        setImagePath(tempImagePath);
      }
    } else {
      setImagePath(null);
    }
  }, [imageCardColumn, data]);

  useEffect(() => {
    if (
      fullscreenImage &&
      fullscreenImage.index === index &&
      fullscreenImage.filePath !== imagePath
    ) {
      if (imagePath) {
        setFullscreenImage({ index, filePath: imagePath });
      } else {
        setFullscreenImage({ index, filePath: null });
      }
    }
  }, [fullscreenImage]);

  return (
    <>
      <CrudMenu
        largeRightPanel={LargeRightPanel}
        menu={menu}
        closePanel={() => {
          menuActions.closeMenus();
          table.reload();
        }}
        onDone={() => {
          menuActions.closeMenus();
          table.reload();
        }}
        selectedData={[data]}
        crudItems={crudItems}
        menuItems={menu.menuItems}
        idColumn={idColumn}
      />
      <div className={classname ?? "CardContainer"}>
        {!hideMenuOptions && (
          <div className="MenuIconContainer">
            <img
              src={menuIcon}
              onClick={() => setMenuOpen(!menuOpen)}
              alt="card menu icon"
              className="MenuIcon"
            />
          </div>
        )}

        <div
          className={`BodyContainer ${hideIcon ? "HideIcon" : ""} ${
            imageCardColumn ? "ImageCard" : ""
          }`}
        >
          {!hideIcon && (
            <div className="IconContainer">
              {customIcon ? (
                customIcon
              ) : image ? (
                <img src={image} alt="Card icon" className="IconImage" />
              ) : (
                <div className="IconText">{iconText}</div>
              )}
            </div>
          )}
          {combineTitleAndType ? (
            <div
              className="CombinedTitleAndType"
              onMouseOver={() =>
                handleTitleOnMouseOver(longTitle, setShowTooltip)
              }
              onMouseLeave={() =>
                handleTitleOnMouseLeave(longTitle, setShowTooltip)
              }
            >
              <div
                className={`Title ${centerCardPageTitle ? "CenterTitle" : ""} ${
                  !maxTitleLength ? "NoMaxWordLength" : ""
                }`}
              >
                {title && typeof title === "string"
                  ? longTitle && maxTitleLength
                    ? `${title.trim().substring(0, maxTitleLength - 3)}...  ${
                        type !== "-" ? `- ${type}` : ""
                      }`
                    : `${title} ${type !== "-" ? `- ${type}` : ""}`
                  : `${type !== "-" ? `${type}` : ""}`}
              </div>
            </div>
          ) : (
            <>
              <div
                className="TitleContainer"
                onMouseOver={() =>
                  handleTitleOnMouseOver(longTitle, setShowTooltip)
                }
                onMouseLeave={() =>
                  handleTitleOnMouseLeave(longTitle, setShowTooltip)
                }
              >
                <div
                  className={`Title ${
                    centerCardPageTitle ? "CenterTitle" : ""
                  } ${!maxTitleLength ? "NoMaxWordLength" : ""}`}
                >
                  {title && typeof title === "string"
                    ? longTitle && maxTitleLength
                      ? `${title.trim().substring(0, maxTitleLength - 3)}...`
                      : title
                    : ""}
                </div>

                {(projectID || clientID) && (
                  <div className="BadgeContainer">
                    {projectID && <div className="ProjectID"> {type}</div>}
                    {clientID && <div className="ClientID"> {type2}</div>}
                  </div>
                )}

                {longTitle && showTooltip && (
                  <CardViewTitleTooltip title={title} />
                )}
              </div>

              {type && !projectID && !clientID && (
                <div className="TypeContainer">
                  <div className="Type">{type}</div>
                </div>
              )}
            </>
          )}

          {imageCardColumn && imagePath && (
            <div className="CardImageThumbnail">
              <img
                src={imagePath}
                // className="ThumbnailsImage"
                // Revoke data uri after image is loaded
                onLoad={() => {
                  //   URL.revokeObjectURL(file?.preview);
                }}
                alt="File preview"
                style={{ width: "100%" }}
                className="FileImagePreview"
                onClick={() => {
                  setFullscreenImage({ index, filePath: imagePath });
                }}
              />
            </div>
          )}

          {imageCardColumn && !imagePath && (
            <div className="NoImage">
              <div className="Text">No Image</div>
            </div>
          )}

          {customContent}
        </div>

        <div className="FooterContainer">
          {footerAction && (
            <div
              className={`Btn ${footerAction.disabled ? "Disabled" : ""}`}
              onClick={() => footerAction.onClick(dataId)}
            >
              {overrideFooterButtonText ?? footerAction.name}
            </div>
          )}
        </div>

        {menuOpen && (
          <div className="MenuContainer" {...bind}>
            {items &&
              Array.isArray(items) &&
              items.length > 0 &&
              items
                .filter((m: any) => !m.notInMenus)
                .map((item: any, key: number) => {
                  return (
                    <div
                      className={`MenuItem ${item.disabled ? "Disabled" : ""}`}
                      onClick={() => {
                        if (!item.disabled) {
                          item.onClick(dataId, data);
                          setMenuOpen(false);
                        }
                      }}
                      key={`card-menu-item-${key}`}
                    >
                      <div className="Text" key={`card-menu-item-text-${key}`}>
                        {applyMaybeString(item.name, data)}
                      </div>
                    </div>
                  );
                })}
          </div>
        )}
      </div>
    </>
  );
};

function CrudMenu<Data>(props: {
  menu: Menu;
  closePanel(): void;
  onDone(): void;
  noun?: string;
  selectedData: Data[];
  crudItems: CrudItems<Data>;
  menuItems: RightMenuItems;
  largeRightPanel?: boolean | ((action?: string | null) => boolean);
  idColumn: string;
  additionalData?: any;
  menuActionsCode?: CrudOptions;
  autoOpenPanel?: (val?: any) => void;
}) {
  const {
    closePanel,
    onDone,
    menu,
    crudItems,
    selectedData,
    autoOpenPanel,
    largeRightPanel,
    idColumn,
    additionalData,
    menuActionsCode,
  } = props;

  const {
    menuItems,
    currentMenu: curMenu, //currentMenuRedirected
  } = menu;

  const [currentMenu, setCurrentMenu] = React.useState(curMenu);

  useEffect(() => setCurrentMenu(curMenu), [curMenu]);
  const currentItem = !currentMenu
    ? null
    : crudItems.find(
        (item: any) =>
          item.menuCode?.toLowerCase() === currentMenu?.toLowerCase()
      );
  const title = () => {
    if (!currentMenu) {
      return "";
    } else if (!currentItem) {
      return "";
    }
    return applyMaybeString(currentItem.title, selectedData);
  };

  const content = () => {
    if (!currentMenu || !currentItem) {
      return null;
    }
    if (crudItems) {
      return currentItem.content(onDone, selectedData, menu, additionalData);
    }
  };

  let rightPanelOpen =
    crudItems && currentMenu
      ? applyMaybeBoolean(currentItem?.inRightPanel ?? true, selectedData)
      : false;

  const checkShouldUseLargePanel = () => {
    if (largeRightPanel === undefined) return false;
    if (typeof largeRightPanel === "boolean") return largeRightPanel;
    else return largeRightPanel(currentItem?.menuCode);
  };

  const shouldUseLargePanel = checkShouldUseLargePanel();

  useEffect(() => {
    if (menuActionsCode) {
      if (rightPanelOpen) closePanel();
      autoOpenPanel && autoOpenPanel(menuActionsCode);
    }
  }, [menuActionsCode]);

  return (
    <React.Fragment>
      {((currentItem && !currentItem.doNotLoadContentInRightPanel) ||
        currentMenu === "FILTERS") && (
        <RightPanel
          title={title()}
          rightPanelContent={rightPanelOpen}
          closePanel={() => {
            closePanel();
          }}
          largeRightPanel={shouldUseLargePanel}
        >
          {content()}
        </RightPanel>
      )}
      {!rightPanelOpen && content()}
    </React.Fragment>
  );
}
